<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Ticket-Integration') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn slot="activator" @click="openAddDialog()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">Şablon Ekle</span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-data-table
            :headers="headerTemplate"
            :items="itemsTemplate"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.TemplateName }}</td>
              <td class="text-xs-left">
                {{ findTemplateTypeName(props.item.TemplateType) }}
              </td>
              <td class="text-xs-left">
                {{ findTemplateTicketTypeName(props.item.TemplateTicketType) }}
              </td>
              <td>
                <v-btn
                  icon
                  class="mx-0"
                  @click="deleteDialogOpen(props.item.TemplateID)"
                >
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mx-0"
                  @click="goDetailPage(props.item.TemplateID)"
                >
                  <v-icon color="teal">search</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="addDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline primary white--text"
            >Şablon Ekle
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="templateType"
                  v-model="templateParams.TemplateType"
                  item-text="text"
                  item-value="value"
                  :label="$t('Template-Type')"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="ticketType"
                  item-text="text"
                  item-value="value"
                  :label="$t('Ticket-Type')"
                  v-model="templateParams.TemplateTicketType"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  :label="$t('Template-Name')"
                  v-model="templateParams.TemplateName"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="addDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary" flat @click="addTemplate()">{{
              $t("save_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialogTemplate" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('Delete') }}</v-card-title>
          <v-card-text>Silmek istediginize eminmisin ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="deleteTemplate()">{{ $t('Delete') }}</v-btn>
            <v-btn color="primary" flat @click="dialogTemplate = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  data() {
    return {
      dialogTemplate: false,
      headerTemplate: [
        {
          text: this.$t("Template-Name"),
          value: "TemplateName",
        },
        {
          text: this.$t('Template-Type'),
          value: "TemplateType",
        },
        {
          text: this.$t("Flight-Type"),
          value: "TemplateTicketType",
        },
        {
          text: this.$t("Process"),
        },
      ],
      itemsTemplate: [],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      templateParams: {
        TemplateID: 0,
        CompanyID: 0,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      },
      ticketType: [
        {
          text: this.$t("Domestic-Line"),
          value: "0",
        },
        {
          text: this.$t("International-Line"),
          value: "2",
        },
      ],
      templateType: [
        {
          text: this.$t("Sales"),
          value: 0,
        },
        {
          text: this.$t('Cost'),
          value: 1,
        },
        {
          text: this.$t("Refund"),
          value: 2,
        },
        {
          text: "İade Maliyet",
          value: 3,
        },
        {
          text: "Tahsilat",
          value: 4,
        },
        {
          text: "İade Tahsilat",
          value: 5,
        },
      ],
      addDialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      templateDeleteId: 0,
    };
  },
  methods: {
    goDetailPage(id) {
      var url = "#/entegrasyon/biletentdetail/id?" + "id=" + id;
      window.open(url, "_blank");
    },
    deleteTemplate() {
      this.loadingvmodel = true;
      let params = {
        TemplateID: this.templateDeleteId,
        CompanyID: this.credentials.MuhasebeSirketNo,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.getList();
            this.loadingvmodel = false;
            this.dialogTemplate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    deleteDialogOpen(id) {
      this.dialogTemplate = true;
      this.templateDeleteId = id;
    },
    findTemplateTicketTypeName(kod) {
      if (kod === undefined) return "";

      let ticket = this.ticketType.find((x) => x.value == kod);
      return ticket.text;
    },
    findTemplateTypeName(kod) {
      if (kod === undefined) return "";

      let template = this.templateType.find((x) => x.value == kod);
      return template.text;
    },
    addTemplate() {
      this.loadingvmodel = true;
      this.templateParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateSave",
          this.templateParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.loadingvmodel = false;
            this.addDialog = false;
            this.getList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    openAddDialog() {
      this.addDialog = true;
    },
    getList() {
      this.loadingvmodel = true;
      let params = {
        TemplateID: 0,
        CompanyID: this.credentials.MuhasebeSirketNo,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.itemsTemplate = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.getList();
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

